// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--Gm2kS";